import PageHero from "../components/sections/PageHero";
import SectionLabel from "../components/ui/SectionLabel";
import ScrollReveal from "../components/motion/ScrollReveal";
import StaggerContainer from "../components/motion/StaggerContainer";
import TiltCard from "../components/motion/TiltCard";

const roles = [
  "Senior Full-Stack Developer (React + Node.js) · Full-time · Remote/Hybrid",
  "AI/ML Engineer (LangChain, RAG, LLM fine-tuning) · Full-time · Remote",
  "UI/UX Designer (Figma, motion, dark aesthetic) · Full-time · Remote/Hybrid",
  "Business Development Manager (B2B tech sales) · Full-time · Remote/Hybrid",
  "Digital Marketing Strategist (SEO + Content) · Part-time · Remote",
  "AI Voice Engineer (Vapi.ai, ElevenLabs, Twilio) · Contract · Remote",
];

const Careers = () => (
  <>
    <PageHero
      label="CAREERS"
      title="Build the"
      titleAccent="intelligent future."
      subtitle="Join us if you're serious about your craft. We ship real products and push the boundaries of digital engineering."
    />
    <section style={{ background: "#050505", padding: "0 0 120px" }}>
      <div style={{ maxWidth: 1100, margin: "0 auto", padding: "0 clamp(20px, 4vw, 48px)" }}>
        
        <StaggerContainer stagger={0.1} style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", gap: 20, marginBottom: 24 }}>
          <TiltCard style={{ background: "#0E0E0E", border: "1px solid rgba(212,168,67,0.18)", borderRadius: 4, padding: 28 }}>
            <SectionLabel text="CULTURE" />
            <p style={{ marginTop: 16, fontFamily: "'DM Sans', sans-serif", fontSize: 14, color: "#F8F4EC", lineHeight: 1.8 }}>
              We ship real things · We think before we build · We own our work
            </p>
          </TiltCard>
          
          <TiltCard style={{ background: "#0E0E0E", border: "1px solid rgba(212,168,67,0.18)", borderRadius: 4, padding: 28 }}>
            <SectionLabel text="PROCESS" />
            <p style={{ marginTop: 16, fontFamily: "'DM Sans', sans-serif", fontSize: 14, color: "#F8F4EC", lineHeight: 1.8 }}>
              Apply → Portfolio Review (48h) → Technical Interview (60 min) → Offer
            </p>
          </TiltCard>
        </StaggerContainer>

        <ScrollReveal direction="up" delay={0.1}>
          <div style={{ background: "#0E0E0E", border: "1px solid rgba(212,168,67,0.18)", borderRadius: 4, padding: "24px clamp(20px, 4vw, 32px)" }}>
            <SectionLabel text="OPEN POSITIONS" />
            <StaggerContainer stagger={0.06} style={{ marginTop: 16 }}>
              {roles.map((role) => (
                <div key={role} style={{ padding: "18px 0", borderBottom: "0.5px solid rgba(212,168,67,0.12)", fontFamily: "'DM Sans', sans-serif", fontSize: 16, color: "#F8F4EC", display: "flex", gap: 12 }}>
                  <span style={{ color: "#D4A843" }}>→</span>
                  {role}
                </div>
              ))}
            </StaggerContainer>
          </div>
        </ScrollReveal>
      </div>
    </section>
  </>
);

export default Careers;
